import { AfterViewInit, Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { WidgetDynamicBaseComponent } from '../../widgets/widgetDynamicBase';

/**
 * This component supports dynamic widget growth and should be wrapped around every widget row or section that should overflow
 */
@Component({
  selector: 'dynamic-growth-row',
  templateUrl: './dynamic-growth-row.component.html',
  styleUrls: ['./dynamic-growth-row.component.scss']
})
export class DynamicGrowthRowComponent implements OnInit, AfterViewInit {
  /**
   * The row number
   */
  @Input() row: number;

  /**
   * The widget
   */
  @Input() widget: WidgetDynamicBaseComponent;

  /**
   * The hidden flag for this row
   */
  public isHidden = false;

  /**
   * Constructor
   * @param viewContainerRef ViewContainerRef
   */
  constructor(public viewContainerRef: ViewContainerRef) {
    //Nothing
  }

  ngOnInit() {
    this.isHidden = this.row < this.widget.getLowerRowIndex() || this.row > this.widget.getUpperRowIndex();
  }


  public ngAfterViewInit() {
    this.widget.registerGrowthRow(this);
  }

  /**
   * Called after the view was initialized. TODO: Do that widget by widget in the data loaded callback of the pages
   */
  public measure() {
    
    this.isHidden = this.row < this.widget.getLowerRowIndex() || this.row > this.widget.getUpperRowIndex();
    if (!this.isHidden) {
      try {
        const widgetBoxElement = this.widget.widgetBox.elementRef.nativeElement;
        const currentEl = this.viewContainerRef.element.nativeElement.firstChild;

        const rectElem = currentEl.getBoundingClientRect();

        const rectBox = widgetBoxElement.getBoundingClientRect();

        const overflow = rectElem.y + rectElem.height > rectBox.y + rectBox.height;
        if (overflow) {
          this.widget.boundsExceeded(this.row, rectElem.height);
        }
        else {
          this.widget.inBounds(this.row, rectElem.height);
        }
      } catch (e) {
        debugger;
        throw e;
      }
    }
  }
}
